<script setup lang="ts">
  import SidebarHeader from './sidebar-header.vue'
  import { useSidebar } from './sidebar-provider.vue'
  import SidebarRailToggle from './sidebar-rail-toggle.vue'
  import { cn } from '@gat-ship/vue-components'
  import { type HTMLAttributes } from 'vue'

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      canToggleRail?: boolean
      railWidth?: number
      width?: number
      header?: {
        title?: string
        description?: string
      }
      contentClass?: string
    }>(),
    {
      canToggleRail: true,
      railWidth: 64,
      width: 356
    }
  )

  const { isRail } = useSidebar()
</script>
<template>
  <div
    :style="{ maxWidth: isRail ? props.railWidth + 'px' : props.width + 'px' }"
    :class="
      cn(
        'left-0 top-0 z-40 h-full w-full overflow-visible',
        {
          'border-border border-r': !(isRail && props.railWidth >= 0)
        },
        props.class
      )
    "
  >
    <div class="relative z-50 flex h-full w-full flex-col">
      <sidebar-rail-toggle v-if="canToggleRail" />
      <sidebar-header
        v-if="header"
        :title="header?.title"
        :description="header?.description"
      >
        <slot name="sidebar-header-content" />
      </sidebar-header>
      <div
        :class="
          cn(
            'flex flex-1 flex-col gap-1.5 overflow-auto overflow-hidden pb-4 pt-5',
            {
              'w-full items-center': isRail,
              'w-full items-start px-5': !isRail
            },
            props.contentClass
          )
        "
      >
        <slot name="main-content" />
      </div>
    </div>
  </div>
</template>
